import { createRouter, createWebHistory } from 'vue-router'
import Top from '../pages/top/Top.vue'
import Post from '../pages/post/Post.vue'
import Admin from '../pages/admin/Admin.vue'

const routes = [
  {
    path: '/',
    name: 'top',
    component: Top
  },
  {
    path: '/post/:id',
    name: 'post',
    component: Post
  },
  {
    path: '/admin',
    name: 'admin',
    component: Admin
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (!savedPosition) {
      return { top: 0 }
    }
    // Topページはスケジュール等のデータを非同期で読み込んでから高さが確定するため、
    // 復元先までスクロールできる高さになるまで少し待ってから復元する
    return new Promise((resolve) => {
      const maxWaitMs = 1500
      const startedAt = Date.now()
      const tryResolve = () => {
        const maxScrollTop = document.documentElement.scrollHeight - window.innerHeight
        if (maxScrollTop >= savedPosition.top || Date.now() - startedAt > maxWaitMs) {
          resolve(savedPosition)
        } else {
          setTimeout(tryResolve, 50)
        }
      }
      setTimeout(tryResolve, 50)
    })
  }
})

export default router